import { useTranslation } from 'react-i18next';

import type { ProposalUserInfo } from '../../types/proposal';
import { PROPOSAL_TABLE_SUBROWS } from '../tables/headers/proposals';

type ProposalSubrowTableProps = ProposalUserInfo & {
  currency?: string;
};

export const ProposalSubrowTable = ({
  id,
  name,
  profile_picture,
  total_amount,
  currency = '€',
  exclusivity,
}: ProposalSubrowTableProps) => {
  const { t } = useTranslation('common');
  return (
    <>
      {/* Col 1: influencer name + avatar */}
      <div className="cell-class truncate px-3 rounded-l-10 text-start border-influentia-black w-full flex-1">
        <div className="flex justify-start pl-[30px]">
          {PROPOSAL_TABLE_SUBROWS.influencer.cell(
            name || t('global.unknown'),
            id,
            profile_picture || '',
            exclusivity,
          )}
        </div>
      </div>
      {/* Col 2: empty (influencers col) */}
      <div className="cell-class truncate px-3 flex-1 w-full" />
      {/* Col 3: empty (status col — could show individual status in future) */}
      <div className="cell-class truncate px-3 flex-1 w-full" />
      {/* Col 4: influencer total amount */}
      <div className="cell-class truncate px-3 flex-1 w-full">
        <div className="flex justify-center">
          {PROPOSAL_TABLE_SUBROWS.amount.cell(total_amount || 0, currency)}
        </div>
      </div>
      {/* Col 5: empty (month col) */}
      <div className="cell-class truncate px-3 rounded-r-10 text-end flex-1 w-full" />
    </>
  );
};
